import ClearCallLogoTitleImg from "../assets/logov2_w_text.png"
import ClearCallTitleImg from "../assets/text_only.png"
import ClearCallLogoImg from "../assets/logov2.png";

interface ClearCallLogoTitleProps {
    size?: number
}

const ClearCallLogoTitle: React.FC<ClearCallLogoTitleProps> = ({
    size
}) => {

    const height = size ? size : 40

    return (
        <img
            src={ClearCallLogoTitleImg}
            alt="Clear Call"
            height={`${height}px`} />
    );
}

interface ClearCallTitleProps {
    size?: number
}

const ClearCallTitle: React.FC<ClearCallTitleProps> = ({
    size
}) => {

    const height = size ? size : 40

    return (
        <img
            src={ClearCallTitleImg}
            alt="Clear Call"
            height={`${height}px`} />
    );
}

interface ClearCallLogoProps {
    size?: number
}

const ClearCallLogo: React.FC<ClearCallLogoProps> = ({
    size
}) => {

    const height = size ? size : 40

    return (
        <img
            src={ClearCallLogoImg}
            alt="Logo"
            height={`${height}px`} />
    );
}

export { ClearCallLogo, ClearCallTitle, ClearCallLogoTitle };